// A drawing only owns the wheel after a deliberate click inside it. Leaving
// the drawing, clicking elsewhere or pressing Escape restores page scrolling.
export function bindClickWheelZoom(node, onChange) {
  const set = (active) => onChange(active);
  const pointerDown = (event) => set(node.contains(event.target));
  const release = () => set(false);
  const keyDown = (event) => { if (event.key === "Escape") release(); };
  set(false);
  document.addEventListener("pointerdown", pointerDown, true);
  node.addEventListener("pointerleave", release);
  document.addEventListener("keydown", keyDown);
  window.addEventListener("blur", release);
  return () => {
    document.removeEventListener("pointerdown", pointerDown, true);
    node.removeEventListener("pointerleave", release);
    document.removeEventListener("keydown", keyDown);
    window.removeEventListener("blur", release);
    release();
  };
}
